/*
 * @Author: wjc
 * @Date: 2023-12-07 11:46:49
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2025-12-15 15:55:38
 * @Description:
 */
const whiteList: string[] = [
  '/auth/register/root',
  '/ent/auth/register',
  '/open/enterprise',
  '/info/open',
  '/infoClass/open',
  '/file/images',
  '/activity/participant/export',
  '/activity/standard/details/export',
  '/singlePage/introductionOfTheAssociation/open',
  '/singlePage/enterpriseShowcase/open',
  '/singlePage/standardPage/open',
  '/open/activityManagement',
  '/open/activityManagement/signIn',
  '/open/activityManagement/signUp',
  '/open/activityManagement/typeEnum',
  '/open/activityManagement/statusEnum',
  '/open/activityManagement/questionTypeEnum',
  '/open/staffManagement/certificate',
  '/open/membershipApplication/configuration',
  '/open/membershipApplication',
]

export default whiteList
